import { render } from "./PaneBuildingsAndFloorPlans.vue?vue&type=template&id=3c0b1ace&scoped=true&ts=true"
import script from "./PaneBuildingsAndFloorPlans.vue?vue&type=script&lang=ts"
export * from "./PaneBuildingsAndFloorPlans.vue?vue&type=script&lang=ts"

import "./PaneBuildingsAndFloorPlans.vue?vue&type=style&index=0&id=3c0b1ace&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\jonatan\\Documents\\Repos\\milva-online\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0b1ace"]])

export default __exports__